export const deClientPortalPlausibilityAnnotations = {
    filterOptions: {
        all: 'Alle',
        general: 'Allgemein',
    },
    newGeneralAnnotationTooltip: 'Neue allgemeine Anmerkung',
    onlyThisDraft: 'Nur von diesem Entwurf',
    newerDraftInfo:
        'Es liegt ein aktuellerer Entwurf vor. Wechseln Sie zum neuesten Entwurf, um neue Anmerkungen und Antworten zu erstellen.',
    notSharedInfo: 'Ihr Gutachter/Ihre Gutachterin kann Ihre Anmerkungen zu diesem Entwurf nicht sehen, bevor Sie sie mit ihm/ihr teilen.',
    sectionTitles: {
        general: 'Allgemeine',
    },
    pdfPageLabel: 'Seite {{page}}',
    textBubble: {
        edit: 'Bearbeiten',
        deleteAnnotation: 'Anmerkung löschen',
        deleteThread: 'Ganze Kette löschen',
        delete: 'Löschen',
        cancel: 'Abbrechen',
        deletedAnnotationText: 'Diese Anmerkung wurde gelöscht.',
        annotationPlaceholder: 'Anmerkung schreiben',
        annotationPlaceholderWithEllipsis: 'Anmerkung schreiben...',
        replyPlaceholder: 'Antwort schreiben',
        replyPlaceholderWithEllipsis: 'Antwort schreiben...',
        reply: 'Antworten',
        edited: 'bearbeitet',
        createdInDraft: 'Erstellt in Entwurf',
        unknownUser: 'Unbekannt',
        deleteModalTitle: 'Anmerkung löschen',
        deleteModalDescription:
            'Sind Sie sicher, dass Sie diese Anmerkung löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        deleteModalDescriptionWithReplies:
            'Sind Sie sicher, dass Sie diese Anmerkung und alle Antworten löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
        notificationTooltip: 'Der Gutachter/die Gutachterin wird im Tagesbericht über neue Anmerkungen informiert.',
        immediatelyVisible: 'Anmerkung sofort sichtbar für Gutachter/in',
    },
}
